/*
 * @Author: Zhouqi
 * @Date: 2025-12-12 17:10:00
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-12 17:10:00
 */

const FaceSwapSkeleton = () => {
  return (
    <div className="relative flex p-[16px] h-full bg-[#f7f7f7] box-border overflow-hidden">
      {/* 左侧操作面板 */}
      <div className="w-[328px] relative bg-[#ffffff] rounded-[8px] overflow-x-hidden flex flex-col">
        {/* 表单区域 */}
        <div className="flex-1 p-[12px] overflow-auto">
          <div className="flex flex-col gap-[16px]">
            {/* 模型选择骨架 */}
            <div className="flex flex-col gap-[8px]">
              <div className="relative h-[32px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>

            {/* 视频上传区域骨架 */}
            <div className="flex flex-col gap-[8px]">
              <div className="flex justify-between items-center">
                <div className="relative h-[16px] bg-gray-200 rounded-[4px] w-[120px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                <div className="relative h-[14px] bg-gray-200 rounded-[4px] w-[60px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
              </div>
              <div className="relative h-[120px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>

            {/* 图片上传区域骨架 */}
            <div className="flex flex-col gap-[8px]">
              <div className="flex justify-between items-center">
                <div className="relative h-[16px] bg-gray-200 rounded-[4px] w-[120px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
                <div className="relative h-[14px] bg-gray-200 rounded-[4px] w-[60px] overflow-hidden">
                  <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                </div>
              </div>
              <div className="relative h-[120px] bg-gray-200 rounded-[6px] overflow-hidden">
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
              </div>
            </div>
          </div>
        </div>

        {/* 底部按钮区域 */}
        <div className="p-[12px] border-t border-gray-200">
          <div className="relative h-[44px] bg-gray-200 rounded-[6px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>
      </div>

      {/* 右侧预览区域 */}
      <div className="flex-1 ml-[16px] relative bg-[#ffffff] rounded-[8px] overflow-hidden flex flex-col p-[24px]">
        {/* 预览播放器骨架 */}
        <div className="flex-1 flex items-center justify-center min-h-0">
          <div className="relative w-full h-full bg-gray-200 rounded-[12px] overflow-hidden">
            <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/60 to-transparent" />
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes shimmer {
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default FaceSwapSkeleton;
